import React from 'react';
import PropTypes from 'prop-types';

// Styles
import styles from './styles/Slider.scss';

class Slider extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            circleXOffset: 0,
            sliderValue: 0,
        };

        this.handleMouseDown = this.handleMouseDown.bind(this);
        this.handleMouseMove = this.handleMouseMove.bind(this);
        this.handleMouseUp = this.handleMouseUp.bind(this);
        this.updateSliderOffset = this.updateSliderOffset.bind(this);
    }

    componentDidMount() {
        this.updateSliderOffset();
    }

    componentDidUpdate(prevProps) {
        if (this.props.defaultCircleXOffset !== prevProps.defaultCircleXOffset) {
            this.updateSliderOffset();
        }
    }

    updateSliderOffset() {
        const linePositions = this.line.getBoundingClientRect();
        const circleXOffset =
            this.props.defaultCircleXOffset * (linePositions.right - linePositions.left);
        this.setState({
            circleXOffset,
        });
    }

    handleMouseDown(event) {
        document.removeEventListener('mousemove', this.handleMouseMove);
        document.removeEventListener('mouseup', this.handleMouseUp);
        document.addEventListener('mousemove', this.handleMouseMove);
        document.addEventListener('mouseup', this.handleMouseUp);
        event.preventDefault();
    }

    handleMouseMove(event) {
        // Get slider's line/track position information
        const linePositions = this.line.getBoundingClientRect();
        // The user's cursor position minus the left edge position of the line gives us the offset from the slider's line start
        const mouseXChange = event.clientX - linePositions.left;

        let circleXOffset;
        // If the user's cursor is greater than the start of the line, but also less than the end of the line,
        // the zoom circle should be positioned at the change in x position, relative to the start of the line.
        // Otherwise, it the user's cursor is at the end/start of the line, the zoom circle should be placed at the
        // start of the line's relative position (0), or at the end of the line's position relative to the start of
        // the line (position of line's right boundary - position of line's left boundary)
        if (event.clientX > linePositions.left && event.clientX < linePositions.right) {
            circleXOffset = mouseXChange;
        } else {
            circleXOffset = mouseXChange >= 0 ? linePositions.right - linePositions.left : 0;
        }

        // Convert position of circle to a value between 0 and 1 and round to nearest tenth
        const value =
            Math.round((circleXOffset / (linePositions.right - linePositions.left)) * 10) / 10;
        // Scale position such that it mimics the scaling of a browser defaulted input range slider and assign an aribtrary
        // y-intercept value that prevents objects from being scaled too small.
        const valueScaled = value * 1.2 + 0.5;

        // Set slider value and position of circle relative to slider
        this.props.onSlide(valueScaled);
        this.setState({
            circleXOffset,
        });
    }

    handleMouseUp() {
        document.removeEventListener('mousemove', this.handleMouseMove);
    }

    render() {
        const circleStyle = {
            transform: `translate3d(${this.state.circleXOffset}px, -50%, 0)`,
        };
        return (
            <div
                className={styles.line}
                ref={line => {
                    this.line = line;
                }}
            >
                <div
                    className={styles.circle}
                    onMouseDown={this.handleMouseDown}
                    style={circleStyle}
                />
            </div>
        );
    }
}

Slider.defaultProps = {
    defaultCircleXOffset: 1,
};

Slider.propTypes = {
    defaultCircleXOffset: PropTypes.number,
    onSlide: PropTypes.func,
};

export default Slider;
